import { UserController, SettingsController } from '../../controllers';
import { appStore, businessStore, useStores } from '../../stores';
import { MimaToastUtil } from '../../components';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { observer } from 'mobx-react';
import { Login } from '../../pages';
import * as yup from 'yup';
import React, { useEffect, useState } from 'react';
import { toJS } from 'mobx';
import { navigateToFirstRoute } from '../../utils/utils';
import { useTrackingEvents } from '../../hooks/useTrackingEvents';

const LoginContainer = () => {
	const { sendTrackingEvent } = useTrackingEvents();

	useEffect(() => {
		sendTrackingEvent(constant.events.page_visit, {
			page_type: 'Login page',
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const [owner, setOwner] = useState(true);

	const selectOwnerAccount = () => {
		setOwner(true);
	};

	const {
		appStore: { loading },
		userStore,
	} = useStores();
	const navigate = useNavigate();

	const validationSchema = () =>
		yup.object({
			email: yup
				.string()
				.trim()
				.email('Enter a valid Email')
				.required('Email Address is required'),
			password: yup.string().required('Password is required'),
			accountType: yup.string().required('Are you a Business Owner/Admin ?'),
		});

	const switchToSignup = () => {
		sendTrackingEvent(constant.events.intent_signup);
		navigate(constant.Routes.SignUp);
	};

	const switchToForgotPassword = () => {
		navigate(constant.Routes.ForgetPassword);
	};

	const onSubmit = async values => {
		appStore.setLoading(true);
		const payload = {
			userEmailMobile: values.email,
			password: values.password,
			accountType: values.accountType,
		};

		const { status, errorMessage } = await UserController.login(payload);

		if (status === constant.InReview) {
			appStore.setLoading(false);
			return navigate(constant.Routes.AccountInReview);
		} else if (status === constant.Success) {
			sendTrackingEvent(constant.events.login_success);
			await SettingsController.runNoAuthSetup();
			if (!userStore.isActivated) {
				localStorage.setItem(
					constant.RouteParams,
					JSON.stringify({
						OtpType: constant.OtpType.ONBOARDING,
					})
				);
				appStore.setLoading(false);
				return navigate(constant.Routes.Otp, {
					state: { OtpType: constant.OtpType.ONBOARDING },
				});
			}
			if (!userStore.user.hasPin) {
				MimaToastUtil.error({
					message: 'Kindly set your PIN on settings page',
				});
			}
			if (
				Object.keys(toJS(businessStore.business)).length !== 0 &&
				!businessStore.business.withdrawalBankAccount
			) {
				MimaToastUtil.error({
					message: 'Kindly set your Withdrawal Account on settings page',
				});
			}
			await SettingsController.dashboardData();
			businessStore.setDefaultCurrency(
				businessStore.business?.settings?.defaultCurrency
			);
			appStore.setLoading(false);
			return navigate(navigateToFirstRoute(userStore.user.permissions));
		} else {
			appStore.setLoading(false);
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
	};

	return (
		<div>
			<Login
				validationSchema={validationSchema}
				onSubmit={onSubmit}
				loading={loading}
				switchToSignup={switchToSignup}
				switchToForgotPassword={switchToForgotPassword}
				owner={owner}
				selectOwnerAccount={selectOwnerAccount}
			/>
		</div>
	);
};

export default observer(LoginContainer);
